import React from "react";

const Contact = () => {
  return (
    <section className="bg-secondery px-5 py-32" id="contact">
      <div className="text-center md:w-[60%] mx-auto text-white">
        <h2 className="text-4xl font-bold mb-5 border-b-[5px] w-[200px] mx-auto border-zinc-500 pb-2">
          Contactos
        </h2>
        <p>
          Estoy abierto a nuevos proyectos. Estoy listo para ponerme en contacto con usted, asi que eres libre de 
          escribirme a mi mail o escribirme por Whatsapp. 
        </p>

        <p className="py-2">
          <span className="font-bold">Email:</span><a href="mailto:"> mateo_penaherrera@yahoo.com</a>
        </p>
        <p className="py-2">
          <span className="font-bold">Phone:</span><a href="https://api.whatsapp.com/send?phone=593999496113"> +593 999496113</a> 
        </p>
      </div>
    </section>
  );
};

export default Contact;
